import clsx from 'clsx';

export const heading = clsx(
  'relative',
  'flex',
  'justify-start',
  'items-center',
  'h-[500px]',
  'md:h-[800px]',
  'bg-center',
  'bg-cover',
  'shadow-xl',
  'px-10',
  'py-16',
  'md:px-48',
  'md:py-50',
);

export const overlay = clsx('absolute', 'inset-0', 'bg-black/50');

export const contentContainer = clsx(
  'relative',
  'flex',
  'flex-col',
  'items-start',
  'w-full',
  'md:w-[60%]'
);

export const titleText = clsx(
  'title',
  'text-[24px]',
  'md:text-6xl',
  'text-background',
  'font-bold'
);

export const descriptionText = clsx(
  'font-subtitle',
  'text-[13px]',
  'text-gray-200',
  'mb-6',
  'mt-4'
);

export const button = clsx(
  'title',
  'flex',
  'flex-row',
  'items-center',
  'gap-1.5',
  'px-10',
  'py-3',
  'bg-background',
  'text-title',
  'text-sm',
  'font-regular',
  'rounded-full',
  'shadow',
  'hover:opacity-90',
);
